(() => {
var $f921149b16c1f5f9$exports = {};
(function() {
    /*
   WooCommerce SkyVerge Payment Gateway My Payment Methods CoffeeScript
   Version 5.1.0

   Copyright (c) 2014-2024, SkyVerge, Inc.
   Licensed under the GNU General Public License v3.0
   http://www.gnu.org/licenses/gpl-3.0.html
  */ jQuery(function($) {
        "use strict";
        // The My Payment Methods handler.
        // @since 5.1.0
        window.SV_WC_Payment_Methods_Handler_v6_1_1 = class SV_WC_Payment_Methods_Handler_v6_1_1 {
            // Constructs the class.
            // @since 5.1.0
            // @param [Object] args, with the properties:
            //     id:         [String] plugin ID
            //     slug:       [String] plugin slug or dasherized ID
            //     i18n:       [Object] localized text strings
            //     ajax_url:   [String] URL for AJAX requests
            //     ajax_nonce: [String] nonce for AJAX requests
            constructor(args){
                // Replace Method column content with Title column content, for FW tokens.
                // @since 5.8.0
                this.replace_method_column = this.replace_method_column.bind(this);
                // Removes duplicate "Default" marks.
                // They are already hidden using CSS, but should also be removed for accessibility.
                // @since 5.8.0
                this.remove_duplicate_default_marks = this.remove_duplicate_default_marks.bind(this);
                // Edits a payment method.
                // @since 5.1.0
                // @param [Object] event jQuery event object
                this.edit_method = this.edit_method.bind(this);
                // Saves a payment method.
                // @since 5.1.0
                // @param [Object] event jQuery event object
                this.save_method = this.save_method.bind(this);
                // Cancels/stop editing a payment method.
                // @since 5.1.0
                // @param [Object] event jQuery event object
                this.cancel_edit = this.cancel_edit.bind(this);
                this.id = args.id;
                this.slug = args.slug;
                this.i18n = args.i18n;
                this.ajax_url = args.ajax_url;
                this.ajax_nonce = args.ajax_nonce;
                // replace the "Method" column content for FW tokens
                this.replace_method_column();
                // remove duplicate "Default" marks
                this.remove_duplicate_default_marks();
                // handle the edit action
                $(".woocommerce-MyAccount-paymentMethods").on('click', ".woocommerce-PaymentMethod--actions .button.edit", (event1)=>{
                    return this.edit_method(event1);
                });
                // handle the save action
                $(".woocommerce-MyAccount-paymentMethods").on('click', ".woocommerce-PaymentMethod--actions .button.save", (event1)=>{
                    return this.save_method(event1);
                });
                // handle the cancel action
                $(".woocommerce-MyAccount-paymentMethods").on('click', ".woocommerce-PaymentMethod--actions .cancel-edit", (event1)=>{
                    return this.cancel_edit(event1);
                });
                // handle the delete action
                $(".woocommerce-MyAccount-paymentMethods").on('click', ".woocommerce-PaymentMethod--actions .button.delete", (event1)=>{
                    var button, row;
                    button = $(event1.currentTarget);
                    row = button.parents('tr');
                    // check if the method belongs to this plugin
                    if (row.find(`input[name=plugin-id][value=${this.slug}]`).length === 0) return;
                    if (!confirm(this.i18n.delete_ays)) {
                        // re-enable the button if user cancels (side note: WooCommerce core is the one that added the disabled state in the first place)
                        button.prop('disabled', false).removeClass('disabled');
                        return event1.preventDefault();
                    }
                });
                // don't follow the Add Payment Method button URL if it's disabled
                $('.button[href*="add-payment-method"]').on('click', event(function() {
                    if ($(this).hasClass('disabled')) return event.preventDefault();
                }));
            }
            replace_method_column() {
                return $('.woocommerce-MyAccount-paymentMethods').find('tr').each((index, element)=>{
                    var titleColumn;
                    // check if the method belongs to this plugin
                    if ($(element).find(`input[name=plugin-id][value=${this.slug}]`).length === 0) return;
                    // delete the Title header
                    $(element).find('th.woocommerce-PaymentMethod--title').remove();
                    titleColumn = $(element).find('td.woocommerce-PaymentMethod--title');
                    // Title column is not empty, this is a FW token
                    if (titleColumn.children().length > 0) // replace Method column
                    $(element).find('td.woocommerce-PaymentMethod--method').html(titleColumn.html());
                    // delete Title column
                    return $(element).find('td.woocommerce-PaymentMethod--title').remove();
                });
            }
            remove_duplicate_default_marks() {
                return $('.woocommerce-MyAccount-paymentMethods').find('tr').each((index, element)=>{
                    return $(element).find('td.woocommerce-PaymentMethod--default').find('mark.default:not(:first-child)').remove();
                });
            }
            edit_method(event1) {
                var button, row;
                event1.preventDefault();
                button = $(event1.currentTarget);
                row = button.parents('tr');
                // check if the method belongs to this plugin
                if (row.find(`input[name=plugin-id][value=${this.slug}]`).length === 0) return;
                row.find('div.view').hide();
                row.find('div.edit').show();
                row.addClass('editing');
                // change the Edit button to "Cancel"
                button.text(this.i18n.cancel_button).removeClass('edit').addClass('cancel-edit').removeClass('button');
                return this.enable_editing_ui();
            }
            save_method(event1) {
                var button, data, row;
                event1.preventDefault();
                button = $(event1.currentTarget);
                row = button.parents('tr');
                // check if the method belongs to this plugin
                if (row.find(`input[name=plugin-id][value=${this.slug}]`).length === 0) return;
                this.block_ui();
                // remove any previous errors
                row.next('.error').remove();
                data = {
                    action: `wc_${this.id}_save_payment_method`,
                    nonce: this.ajax_nonce,
                    token_id: row.find('input[name=token-id]').val(),
                    data: row.find('input[name]').serialize()
                };
                return $.post(this.ajax_url, data).done((response)=>{
                    if (!response.success) return this.display_error(row, response.data);
                    if (response.data.title != null) row.find('.woocommerce-PaymentMethod--method').html(response.data.title);
                    if (response.data.nonce != null) this.ajax_nonce = response.data.nonce;
                    // change the "Cancel" button back to "Edit"
                    button.siblings('.cancel-edit').removeClass('cancel-edit').addClass('edit').text(this.i18n.edit_button).addClass('button');
                    row.removeClass('editing');
                    return this.disable_editing_ui();
                }).fail((jqXHR, textStatus, error)=>{
                    return this.display_error(row, error);
                }).always(()=>{
                    return this.unblock_ui();
                });
            }
            cancel_edit(event1) {
                var button, row;
                event1.preventDefault();
                button = $(event1.currentTarget);
                row = button.parents('tr');
                // check if the method belongs to this plugin
                if (row.find(`input[name=plugin-id][value=${this.slug}]`).length === 0) return;
                row.find('div.view').show();
                row.find('div.edit').hide();
                row.removeClass('editing');
                // change the "Cancel" button back to "Edit"
                button.removeClass('cancel-edit').addClass('edit').text(this.i18n.edit_button).addClass('button');
                return this.disable_editing_ui();
            }
            // Sets the page UI to the "editing" state.
            // This brings proper focus to the method being edited and prevents
            // other available buttons/actions until the editing is finished or cancelled.
            // @since 5.1.1
            enable_editing_ui() {
                // set the methods table as 'editing'
                $(".woocommerce-MyAccount-paymentMethods").addClass('editing');
                // disable the Add Payment Method button
                return $('.button[href*="add-payment-method"]').addClass('disabled');
            }
            // Sets the page UI back to the default state.
            // @since 5.1.1
            disable_editing_ui() {
                // removes the methods table's "editing" status
                $(".woocommerce-MyAccount-paymentMethods").removeClass('editing');
                // re-enable the Add Payment Method button
                return $('.button[href*="add-payment-method"]').removeClass('disabled');
            }
            // Blocks the payment methods table UI.
            // @since 5.1.0
            block_ui() {
                return $(".woocommerce-MyAccount-paymentMethods").parent('div').block({
                    message: null,
                    overlayCSS: {
                        background: '#fff',
                        opacity: 0.6
                    }
                });
            }
            // Unblocks the payment methods table UI.
            // @since 5.1.0
            unblock_ui() {
                return $(".woocommerce-MyAccount-paymentMethods").parent('div').unblock();
            }
            // Displays an error message to the user.
            // @since 5.1.0
            // @param [Object] row payment method table row
            // @param [String] error raw error message
            // @param [String] message user error message
            display_error(row, error, message = '') {
                var columns;
                console.error(error);
                if (!message) message = this.i18n.save_error;
                columns = $(".woocommerce-MyAccount-paymentMethods thead tr th").length;
                return $('<tr class="error"><td colspan="' + columns + '">' + message + '</td></tr>').insertAfter(row).find('td').delay(8000).slideUp(200);
            }
        };
        // dispatch loaded event
        return $(document.body).trigger('sv_wc_payment_methods_handler_v6_1_1_loaded');
    });
}).call($f921149b16c1f5f9$exports);

})();
//# sourceMappingURL=sv-wc-payment-gateway-my-payment-methods.js.map
